// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"b262666b","266":"9b35ae09","957":"066c5117"}[chunkId] + ".chunk.js";
};